// extracted by css-extract-rspack-plugin
export default {"modalHeader":"UBfXLGAHBEkfT9mq__modalHeader___"};